import { Check, Clock, TriangleAlert, Undo2 } from 'lucide-react'
import { Badge } from '@/components/sv/badge'
import type { Invoice } from '@/graphql.types'

export const InvoiceStatusBadge = ({
  invoice,
}: {
  invoice?: Partial<Invoice> | null
}) => {
  if (!invoice) {
    return null
  }

  if (invoice.status === 'processing') {
    return (
      <Badge variant="outline">
        <Clock aria-hidden="true" />
        Processing
      </Badge>
    )
  }
  if (invoice.status === 'failed') {
    return (
      <Badge variant="destructive">
        <TriangleAlert aria-hidden="true" /> Failed
      </Badge>
    )
  }
  if (invoice.status === 'refunded') {
    return (
      <Badge variant="outline">
        <Undo2 aria-hidden="true" />
        Refunded
      </Badge>
    )
  }
  if (invoice.status === 'unpaid') {
    return (
      <Badge variant="destructive">
        <TriangleAlert aria-hidden="true" /> Unpaid
      </Badge>
    )
  }
  if (invoice.status === 'forgiven') {
    return (
      <Badge variant="outline">
        <Check aria-hidden="true" />
        Forgiven
      </Badge>
    )
  }
  if (invoice.status === 'closed') {
    return (
      <Badge variant="outline">
        <Check aria-hidden="true" />
        Closed
      </Badge>
    )
  }
  if (invoice.status === 'upcoming') {
    return (
      <Badge variant="outline">
        <Clock aria-hidden="true" />
        Draft
      </Badge>
    )
  }
  if (invoice.status === 'succeeded') {
    return (
      <Badge variant="emerald">
        <Check aria-hidden="true" />
        Paid
      </Badge>
    )
  }
  if (invoice.status === 'overdue') {
    return (
      <Badge variant="destructive">
        <TriangleAlert aria-hidden="true" /> Past due
      </Badge>
    )
  }

  return null
}
